const PREFIX = 'finances.swr.v1:';
const memory = new Map();

const storageKey = key => `${PREFIX}${key}`;

export const readCache = key => {
  if (memory.has(key)) return memory.get(key);
  try {
    const raw = window.localStorage.getItem(storageKey(key));
    const envelope = raw ? JSON.parse(raw) : null;
    if (!envelope || envelope.version !== 1 || !envelope.savedAt) return null;
    memory.set(key, envelope);
    return envelope;
  } catch (error) {
    console.warn(`Could not read ${key} cache`, error);
    return null;
  }
};

export const writeCache = (key, data, savedAt = new Date().toISOString()) => {
  const envelope = { version: 1, savedAt, data };
  memory.set(key, envelope);
  try {
    window.localStorage.setItem(storageKey(key), JSON.stringify(envelope));
  } catch (error) {
    console.warn(`Could not persist ${key} cache`, error);
  }
  return envelope;
};

export const removeCache = key => {
  memory.delete(key);
  try {
    window.localStorage.removeItem(storageKey(key));
  } catch (error) {
    console.warn(`Could not remove ${key} cache`, error);
  }
};

export const clearCaches = () => {
  memory.clear();
  try {
    Object.keys(window.localStorage)
      .filter(key => key.startsWith(PREFIX))
      .forEach(key => window.localStorage.removeItem(key));
    window.localStorage.removeItem('cashflow.v2.last-good');
  } catch (error) {
    console.warn('Could not clear dashboard caches', error);
  }
};

export const cacheAge = envelope => envelope?.savedAt
  ? Math.max(0, Date.now() - new Date(envelope.savedAt).getTime())
  : Infinity;
